import { render, staticRenderFns } from "./Traditionista.vue?vue&type=template&id=32dcc123&scoped=true&"
import script from "./Traditionista.vue?vue&type=script&lang=js&"
export * from "./Traditionista.vue?vue&type=script&lang=js&"
import style0 from "./Traditionista.vue?vue&type=style&index=0&id=32dcc123&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32dcc123",
  null
  
)

export default component.exports